<template>
  <section class="section is-grey-lighter notification" id="timeline">
    <div class="container">
      <h2 class="title has-text-european padtop">Timeline</h2>
      <div class="timeline is-centered pb-4">
        <header class="timeline-header">
          <span class="tag is-medium is-size-4 is-european">2020</span>
        </header>
        <div class="timeline-item">
          <div class="timeline-marker"></div>
          <div class="timeline-content">
            <p class="heading">Mars 2020</p>
            <h3 class="is-size-4">Kick-off Meeting</h3>
            <p class="heading">Amsterdam Pays-Bas</p>
          </div>
        </div>
        <div class="timeline-item">
          <div class="timeline-marker belgian"></div>
          <div class="timeline-content">
            <p class="heading">Novembre 2020</p>
            <h3 class="is-size-4">Kikk Festival</h3>
            <p class="heading">Namur Belgique</p>
            <p>Annulation due au Covid-19</p>
          </div>
        </div>
        <header class="timeline-header">
          <span class="tag is-european is-large">2021</span>
        </header>
        <div class="timeline-item">
          <div class="timeline-marker"></div>
          <div class="timeline-content">
            <p class="heading">Mars 2021</p>
            <h3 class="is-size-4">Hackathon 1</h3>
            <p class="heading">Amsterdam Pays-Bas</p>
            <p>
              <a href="https://youtu.be/XfoQKP6AV10" target="_blank"
                >Aftermovie</a
              >
            </p>
          </div>
        </div>
        <div class="timeline-item">
          <div class="timeline-marker"></div>
          <div class="timeline-content">
            <p class="heading">Octobre 2021</p>
            <h3 class="is-size-4">Hackathon 2</h3>
            <p class="heading">Bielefeld Allemagne</p>
            <a
              href="https://www.nweurope.eu/projects/project-search/it4anxiety-managing-anxiety-via-innovative-technologies-for-better-mental-health/#tab-7"
              target="_blank"
              >website (EN)</a
            >
          </div>
        </div>
        <div class="timeline-item">
          <div class="timeline-marker belgian"></div>
          <div class="timeline-content">
            <p class="heading">Novembre 2021</p>
            <h3 class="is-size-4">KIKK Festival</h3>
            <p class="heading">Namur Belgique</p>
          </div>
        </div>
        <header class="timeline-header">
          <span class="tag is-european is-large">2022</span>
        </header>
        <div class="timeline-item">
          <div class="timeline-marker"></div>
          <div class="timeline-content">
            <p class="heading">Janvier 2022</p>
            <h3 class="is-size-4">Hackathon 3</h3>
            <p class="heading">Lille France</p>
          </div>
        </div>
        <div class="timeline-item">
          <div class="timeline-marker belgian"></div>
          <div class="timeline-content">
            <p class="heading">20-21-22 avril 2022</p>
            <h3 class="is-size-4">Hackathon 4</h3>
            <p class="heading">Namur Belgique</p>
            <a
              href="https://youtu.be/Xhftf3e-OIc"
              target="_blank"
              >Aftermovie</a
            >
            <br>
            <a
              href="https://www.nweurope.eu/projects/project-search/it4anxiety-managing-anxiety-via-innovative-technologies-for-better-mental-health/events/it4anxietys-fourth-hackathon-in-namur-belgium-we-have-3-winners/"
              target="_blank"
              >Débriefing (EN)</a
            >
          </div>
        </div>
        <div class="timeline-item">
          <div class="timeline-marker"></div>
          <div class="timeline-content">
            <p class="heading">Juin 2022</p>
            <h3 class="is-size-4">Hackathon 5</h3>
            <p class="heading">Royaume-Uni</p>
            <a href="https://www.youtube.com/watch?v=yhza_lsqrCA"
            target="_blank"
            >
            Aftermovie
            </a>
          </div>
        </div>
        <div class="timeline-item">
          <div class="timeline-marker"></div>
          <div class="timeline-content">
            <p class="heading">11 Octobre 2022</p>
            <h3 class="is-size-4">Conférence de mi-parcours</h3>
            <p class="heading">France</p>
            <a href="https://www.youtube.com/watch?v=OX_61b3vwxc" target="_blank">
              Aftermovie
            </a>
          </div>
        </div>
        <div class="timeline-item">
          <div class="timeline-marker belgian"></div>
          <div class="timeline-content">
            <p class="heading">Novembre 2022</p>
            <h3 class="is-size-4">KIKK Festival</h3>
            <p class="heading">Namur Belgique</p>
            <!-- <a href="/presse/anxiété_technologie_et_vous.pdf" target="_blank">Evenement/formation: L’anxiété, la technologie et vous</a> -->
          </div>
        </div>
        <header class="timeline-header">
          <span class="tag is-european is-large">2023</span>
        </header>
        <div class="timeline-item">
          <div class="timeline-marker belgian"></div>
          <div class="timeline-content">
            <p class="heading">13 avril 2023</p>
            <h3 class="is-size-4">Conférence nationale</h3>
            <p class="heading">Namur Belgique</p>
            <p><a href="https://youtu.be/JPVBKJDJOM4" target="_blank">
              Aftermovie
            </a></p>
          </div>
        </div>
        <div class="timeline-item">
          <div class="timeline-marker belgian"></div>
          <div class="timeline-content">
            <p class="heading">29 juin 2023</p>
            <h3 class="is-size-4">Conférence de clôture</h3>
            <p class="heading">Namur Belgique</p>
            <p><a href="https://www.conffinale.it4anxiety.eu" target="_blank">
              Informations
            </a></p>
            <p><a href="https://youtu.be/Tnoi280t8Nk" target="_blank">
              Aftermovie
            </a></p>
            <p><a href="https://www.youtube.com/watch?v=Tlz-sKQBfcw" target="_blank">
              Captation
            </a></p>
          </div>
        </div>
        <div class="timeline-header">
          <span class="tag is-medium is-size-4 is-european">fin</span>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  methods: {
    alertCustom() {
      this.$buefy.dialog.alert({
        title: "Bientôt",
        message:
          "Vous retrouverez plus d'informations ici prochainement, n'hésitez pas à repasser ou nous suivre sur les réseaux sociaux",
        confirmText: "Ok",
      });
    },
  },
};
</script>

<style scoped lang="scss">
.belgian {
  border: #fbbf1c 1px solid !important;
  background-color: #fbbf1c !important;
}
</style>